import { $qs, $qsa } from '@js/utils/querySelector';
import { media } from '@js/utils/mediaQueries';
import gsap from 'gsap';


function getScale(element) {
    // Get the computed style of the element
    const style = window.getComputedStyle(element);
    // Get the transform matrix from the style
    const transform = style.transform || style.webkitTransform || style.mozTransform;
    // If there is no transform, return the default scale of 1
    if (!transform || transform === 'none') {
        return 1;
    }
    // Parse the matrix values
    const matrix = transform.match(/^matrix\((.+)\)$/);
    if (matrix) {
        // Split the matrix values and return the scale (a = matrix[1])
        const values = matrix[1].split(', ');
        const scaleX = parseFloat(values[0]);
        // Assuming uniform scaling, you can return scaleX
        return scaleX;
    }
    // Parse the matrix3d values
    const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        // Split the matrix3d values and return the scale (a = matrix3d[0])
        const values = matrix3d[1].split(', ');
        const scaleX = parseFloat(values[0]);
        // Assuming uniform scaling, you can return scaleX
        return scaleX;
    }
    // If no valid transform matrix is found, return the default scale of 1
    return 1;
}


function cursor(block) {
    const videos = $qsa('[data-target="video"]', block);

    if (!media.lg) return;

    [...videos].forEach(video => {
        const videoCursor = $qs('[data-target="video-cursor"]', video);
        const videoSlideParent = video.closest('.swiper-slide');
        let insideVideo = false;
        let lastMouseX = 0;
        let lastMouseY = 0;

        if (videoCursor) {
            gsap.set(videoCursor, {xPercent: -50, yPercent: -50});

            let xTo = gsap.quickTo(videoCursor, 'x', {duration: 0.6, ease: 'power3'});
            let yTo = gsap.quickTo(videoCursor, 'y', {duration: 0.6, ease: 'power3'});

            const updateCursorPosition = () => {
                if (insideVideo) {
                    const scale = videoSlideParent ? getScale(videoSlideParent) : 1; // Ensure this function returns the correct scale
                    const rect = video.getBoundingClientRect();

                    const mouseX = (lastMouseX - rect.left) / scale;
                    const mouseY = (lastMouseY - rect.top) / scale;

                    xTo(mouseX - (video.clientWidth / 2));
                    yTo(mouseY - (video.clientHeight / 2));
                } else {
                    xTo(0);
                    yTo(0);
                }
            };

            window.addEventListener('mousemove', e => {
                lastMouseX = e.clientX;
                lastMouseY = e.clientY;
                updateCursorPosition();
            });

            window.addEventListener('scroll', updateCursorPosition);
        }

        video.addEventListener('mouseenter', () => {
            insideVideo = true;
        });
    
        video.addEventListener('mouseleave', () => {
            insideVideo = false;
        });
    });
}

function singleMedia() {
    const blocks = $qsa('[data-block="single-media"]');

    if (!blocks) return;
    
    blocks.forEach(block => {
        cursor(block);
    });
}

export default singleMedia;